import r from "./index313.js";
import { resolveComponent as t, createBlock as n, openBlock as s } from "vue";
import c from "./index231.js";
function p(e, i, a, m, l, _) {
  const o = t("ms-ad-place");
  return s(), n(o, {
    placementId: e.getPlacementId(),
    isMobile: !0,
    isInDisturber: e.isInDisturber
  }, null, 8, ["placementId", "isInDisturber"]);
}
const I = /* @__PURE__ */ c(r, [["render", p]]);
export {
  I as default
};
